import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import { ApartmentCompareChartData } from '../type/ApartmentCompare.type';

interface ApartmentCompareCardLineChartProps {
  chartDataList: ApartmentCompareChartData[];
  aptName: string;
}

const formatManwon = (value: number) => {
  if (value >= 10000) {
    return (value / 10000).toFixed(1).replace(/\.0$/, '') + '억';
  }
  return value.toLocaleString() + '만';
};

const ApartmentCompareCardLineChart = ({ chartDataList, aptName }: ApartmentCompareCardLineChartProps) => {
  useEffect(() => {
    const dom = document.getElementById('apartment-compare-chart');
    if (!dom) return;

    const chart = echarts.init(dom);
    const option = {
      animation: false,
      tooltip: {
        trigger: 'axis',
        formatter: (params: any[]) => {
          const lines = params.map((p: any) => {
            const val = p.value != null ? formatManwon(p.value) + '원' : '-';
            return `${p.marker}${p.seriesName}: ${val}`;
          });
          return `${params[0]?.axisValue}<br/>${lines.join('<br/>')}`;
        },
      },
      legend: {
        data: ['순자산', aptName],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: chartDataList.map((d) => d.yearMonth),
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value: number) => formatManwon(value),
        },
      },
      series: [
        {
          name: '순자산',
          type: 'line',
          data: chartDataList.map((d) => d.netAssetManwon ?? null),
          lineStyle: { color: '#2196F3' },
          itemStyle: { color: '#2196F3' },
          symbol: 'circle',
          symbolSize: 6,
          connectNulls: true,
        },
        {
          name: aptName,
          type: 'line',
          data: chartDataList.map((d) => d.aptPrice ?? null),
          lineStyle: { color: '#FF9800' },
          itemStyle: { color: '#FF9800' },
          symbol: 'circle',
          symbolSize: 6,
          connectNulls: false,
        },
      ],
    };
    chart.setOption(option);

    const handleResize = () => chart.resize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      chart.dispose();
    };
  }, [chartDataList, aptName]);

  return <div id="apartment-compare-chart" className="w-full h-72"></div>;
};

export default ApartmentCompareCardLineChart;
